import { render, staticRenderFns } from "./acesso-sistema.vue?vue&type=template&id=748089c0"
import script from "./acesso-sistema.vue?vue&type=script&lang=js"
export * from "./acesso-sistema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports